import { getValueFromCookie } from '@/utils/cookie';
import Constants from '@/constants/const';

// preorder取默认地址
export const getSelectAddress = (ctx?) => {
  return getValueFromCookie(Constants.SELECT_ADDRESS, ctx);
};

/**
 *
 * @returns 是否是直邮区域
 */
export const isShippingOrder = (ctx?): boolean => {
  const isShippingOrder = getValueFromCookie(Constants.IS_SHIPPING_ORDER, ctx);
  return isShippingOrder === Constants.IS_SHIPPING_ORDER_VAL.IS;
};

/**
 *
 * @returns 是否支持切换日期
 */
export const isSupportChangeDate = (ctx?): boolean => {
  return getValueFromCookie(Constants.IS_SUPPORT_CHANGE_DATE, ctx) === Constants.IS_SHIPPING_ORDER_VAL.IS;
};

/**
 *
 * @param ctx 获取当前的zipcode
 * @returns
 */
export const getZipcode = (ctx?) => {
  return getValueFromCookie(Constants.ZIP_CODE, ctx);
};

/**
 *
 * @param ctx 获取当前的城市
 * @returns
 */
export const getAddressCity = (ctx?) => {
  return getValueFromCookie(Constants.ADDRESS_CITY, ctx);
};

/**
 *
 * @param ctx 获取当前的配送日期
 * @returns
 */
export const getDeliveryDate = (ctx?) => {
  return getValueFromCookie(Constants.DELIVERY_DATE, ctx);
};

/**
 *
 * @param ctx 获取配送的销售组织id
 * @returns
 */
export const getSalesOrgId = (ctx?) => {
  return getValueFromCookie(Constants.SALES_ORG_ID, ctx);
};

export const getIsSupportGlobal = (ctx?) => {
  return `${getValueFromCookie(Constants.IS_SUPPORT_GLOBAL, ctx)}` === '1';
};
